module.exports = __webpack_public_path__ + "img/sms-title.dd199187.png";